import React, { createContext, useReducer } from "react";
import Reducer from './Reducer'
import AsyncStorage from '@react-native-async-storage/async-storage';
import useMounted from "../../hooks/useMounted";
import http from "../../utils/http";
import { SafeJSONArray } from "../../constants/Utils";
import { IOrderContextState, IOrderContextValue, OrderContextActionTypes } from "../../interfaces/order";


const initialState: IOrderContextState = {
    order_group: [],
    order_group_pending: [],
    order_group_cancelled: [],
    order_group_completed: [],
    latest_order: null,
    loading: false,
    error: null,
};

const OrderStore = ({ ...props }) => {
    const isMounted = useMounted();
    const [state, dispatch] = useReducer(Reducer, initialState);

    const action = async () => {
        let token = await AsyncStorage.getItem('userToken') || '';
        let buyer = await AsyncStorage.getItem('buyerId') || '';
        let buyerOrderGroup = SafeJSONArray(await AsyncStorage.getItem('buyerOrderGroup'));

        isMounted.current && dispatch({ type: OrderContextActionTypes.set, payload: buyerOrderGroup || [] });

        return new Promise((resolve, reject) => {

            // read user's order / , if any exists
            let form = new FormData()
            form.append('buyer_id', buyer)

            http.post('order_group/read_by_buyer', form, token)
                .then(order_group_res => {
                    if (order_group_res.code === 200) {
                        AsyncStorage.setItem('buyerOrderGroup', JSON.stringify(order_group_res.data))
                        isMounted.current && dispatch({ type: OrderContextActionTypes.set, payload: order_group_res.data })

                        resolve(order_group_res.data)
                    } else {
                        const msg = order_group_res.message
                        reject({ message: msg })
                    }
                }).catch(err => {
                    reject(err)
                })

        })
    }

    return (
        <OrderContext.Provider value={{ state, dispatch, action }}>
            {props.children}
        </OrderContext.Provider>
    )
};

export const OrderContext = createContext<IOrderContextValue>({
    state: initialState,
    dispatch: () => null,
    action: () => null
});
export default OrderStore;